module.exports = __webpack_public_path__ + "resource/img/announcement.e8489673.svg";